import { render, staticRenderFns } from "./login-v2.vue?vue&type=template&id=0e641f96&scoped=true&"
import script from "./login-v2.vue?vue&type=script&lang=js&"
export * from "./login-v2.vue?vue&type=script&lang=js&"
import style1 from "./login-v2.vue?vue&type=style&index=1&id=0e641f96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e641f96",
  null
  
)

export default component.exports